import CashIcon from "@/assets/icons/banknotes.svg";
import { useMentionCard } from "@/containers/MentionCard/context";
import { useI18n } from "@/contexts/i18nContext";
import { round } from "@/utils";
import Highlight from "@components/Highlight";
import Tooltip from "@components/Tooltip";

const PRValue = () => {
  const {
    pr_value,
    episode: { reach },
  } = useMentionCard();
  const { formatCurrency } = useI18n();

  if (!reach || !pr_value) {
    return null;
  }

  return (
    <Tooltip content={L.MENTIONS_PR_VALUE_HOW_CALCULATED}>
      <a
        href={L.HELP_ARTICLE_PR_VALUE}
        target="_blank"
        rel="noreferrer"
        data-testid="pr-value-help-article-link"
      >
        <span data-testid="episode-pr-value">
          <Highlight
            icon={CashIcon}
            className="pr-value"
            label={formatCurrency(round(pr_value))}
          />
        </span>
      </a>
    </Tooltip>
  );
};

export default PRValue;
